import apiClient from "./apiClient";

export const createServer = async (payload) => {
  try {
    const res = await apiClient.post("/server/create", payload);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const getAllServers = async () => {
  try {
    const res = await apiClient.get("/server/get-all-servers");
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const getServerById = async (id) => {
  try {
    const res = await apiClient.get(`/server/${id}`);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const deleteServer = async (id) => {
  try {
    const res = await apiClient.delete(`/server/delete-server/${id}`);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const addActionInServer = async (payload, serverId = null) => {
  const serverIdToUse = serverId || localStorage.getItem("server_id");
  try {
    const res = await apiClient.put("/server/add-action", payload, {
      headers: { mcp_server_id: serverIdToUse },
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const serverUpdateSecret = async () => {
  const serverId = localStorage.getItem("server_id");
  try {
    const res = await apiClient.put("/server/update-secrets", {}, {
      headers: { mcp_server_id: serverId },
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const getServerSecrets = async () => {
  const serverId = localStorage.getItem("server_id");
  try {
    const res = await apiClient.get("/server/get-secrets", {
      headers: { mcp_server_id: serverId },
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};
